// extracted by mini-css-extract-plugin
module.exports = {"topicPill":"styles-module__topicPill___3uPbu"};